<template>
  <div>
    <el-card class="box-card" shadow="never">
      <div slot="header" class="clearfix">
        <span>订单支付</span>
      </div>
      <div>
        <el-card class="addr-wrap" shadow="never">
          <div slot="header" class="clearfix">
            <span>收货信息</span>
            <el-button size="mini" @click="beforeCreateAddress">新建收货地址</el-button>
          </div>
          <div v-if="addlist.length>0">
            <div :class="['consignee-content',consignee?'open':'off']">
              <div class="switchable-panel" v-for="(item,index) in addrList" :key="index">
                <div class="item-select">
                  <el-radio v-model="radio" :label="item.id" border size="medium">{{item.receive}}</el-radio>
                </div>
                <div class="addr-detail"><span class="info-l"><span class="addr-name">{{item.receive}} {{item.phone}}</span><span class="addr-info">{{(item.province=="其他"?"":item.province)+' '+(item.city=="其他"?"":item.city) +' '+(item.area=="其他"?"":item.area) +' '+ item.address}}</span></span><span v-if="item.is_default==='1' || item.is_default===1" class="addr-default">默认</span></div>
                <div class="op-btns"><a href="javascript:;" @click="setDefaultAddress(item.id)" v-if="item.is_default==1?false:true">设为默认</a><a href="javascript:;" @click="beforeUpdateAddress(item)">编辑</a><a href="javascript:;" @click="deleteAdress(item.id)">删除</a></div>
              </div>

            </div>
            <div :class="['addr-switch',{'switch-off':consignee}]" v-if="addlist.length>1" @click="consigneeAll()">
              <span>{{consigneeTxt}}</span><b></b>
            </div>
          </div>
        </el-card>
        <el-card class="cart-item" shadow="never">
          <div slot="header" class="clearfix">
            <span>作品信息</span>
          </div>
          <div class="cart-item-body" v-for="(item,index) in list" v-bind:key="index">
            <div class="goods-item">
              <div class="goods-main">
                <div class="goods-img">
                  <img :src="item.Photo" alt="">
                </div>
                <div class="goods-msg">
                  <div class="name">{{item.ProductName}}</div>
                  <div class="extra">
                    <p class="info">作品编号：{{item.Suffix1}}</p>
                    <p class="info">作者： {{item.ArtistName}}</p>
                  </div>
                </div>
              </div>
            </div>
            <div class="amount">
              <p class="">成交价：<span class="span">￥{{item.DealPrice}}</span></p>
            </div>
          </div>
        </el-card>

        <el-card class="cart-item" shadow="never">
          <div slot="header" class="clearfix">
            <span>支付方式</span>
          </div>
          <div>
            <div class="payment-panel">
              <div class="payment-item">
                <el-radio v-model="payType" label="NATIVE">微信支付</el-radio>
              </div>
              <div class="payment-item">
                <el-radio v-model="payType" label="underline">线下支付</el-radio>
              </div>
            </div>
            <div class="checkout-summary clearfix">
              <div class="summary-r"><span class="text-l">实付款(包邮)：</span><span class="price">￥{{realPrice}}</span></div>
            </div>
            <div class="checkout-submit">
              <el-button type="warning" :disabled="!btnState" @click="createdNativePay">立即支付</el-button>
            </div>
          </div>
        </el-card>
      </div>
    </el-card>

    <el-dialog :close-on-click-modal="false" title="提示" @close="clearOrderQueryInterval" :visible.sync="showDialog">
      <div class="qrcode clearfix" v-if="payType==='NATIVE'">
        <div class="qrcode-img"><img :src="QRImages" alt=""></div>
        <div class="">
          <p>使用微信扫描上方二维码即可完成支付。 订单已生成，如果未完成支付，请刷新页面重试</p>
          <el-button type="primary" plain @click="payOrderQuery">支付成功</el-button>
          <el-popover placement="top-start" title="出错了？" width="200" trigger="click" content="没有看到二维码？请刷新页面试试">
            <el-button slot="reference">遇到问题</el-button>
          </el-popover>
        </div>
      </div>
      <div class="alert_main bank_wrap" v-if="payType==='underline'">
        <div class="bank_bg"></div>
        <div class="bank_hd">
          <div class="bank_logo">
            <img src="../../assets/image/hx_bank_logo.png" alt="">
          </div>
          <div class="bank_info">
            <p class="bank_name">招商银行北京宣武门支行</p>
            <p class="payee">账户名：北京杏坛艺讯拍卖有限公司</p>
          </div>
        </div>
        <div class="bank_bd gotham">
          1109 3048 9310 802
        </div>
        <div class="bank_ft">
          <p class="content">客服电话： <strong>13051002606</strong>（包经理）</p>
          <p class="content">备注：请注明拍品信息，及时联系客服发货.</p>
        </div>
      </div>
    </el-dialog>
    <dialogAddress @close="handleFormVisibleClose" @dialogTarget="handleDialogTarget" :form="form" :dialog="dialogFormVisible"></dialogAddress>
  </div>
</template>
<style lang="scss">
.addr-wrap .el-card__body {
  padding: 0;
}
.switchable-panel .item-select .el-radio--medium.is-bordered {
  width: 120px;
}
</style>
<style lang="scss" scoped>
.consignee-content {
  padding: 12px 0;
}
.consignee-content.open {
  max-height: 200px;
  overflow: auto;
}
.consignee-content.off {
  height: 46px;
  max-width: inherit;
  overflow: hidden;
}
.switchable-panel {
  display: flex;
  justify-content: space-around;
  height: 40px;
  margin-top: 3px;
  margin-bottom: 3px;
  .addr-detail {
    line-height: 40px;
    font-size: 12px;
    flex: 0 0 400px;
    .info-l {
      display: inline-block;
      max-width: 350px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      vertical-align: middle;
      .addr-name {
        margin-right: 10px;
      }
    }
    .addr-default {
      display: inline-block;
      margin: 5px 10px;
      background-color: #999;
      color: #fff;
      padding: 0 3px;
      line-height: 20px;
    }
  }
  .item-select {
    vertical-align: middle;
    .el-radio--medium.is-bordered {
      margin-top: 2px;
    }
  }
  .op-btns {
    flex: 0 0 140px;
    visibility: hidden;
    a {
      line-height: 40px;
      color: #cfa972;
      margin-right: 10px;
      font-size: 13px;
    }
  }
  &:hover {
    background-color: #fff3f3;
    .op-btns {
      visibility: initial;
    }
  }
}
.addr-switch {
  height: 18px;
  line-height: 18px;
  padding: 5px 20px;
  cursor: pointer;
  font-size: 12px;
  b {
    display: inline-block;
    vertical-align: middle;
    height: 10px;
    line-height: 10px;
    width: 9px;
    margin-left: 5px;
    background: url(../../assets/image/addr-i.png) no-repeat 0 0;
  }
}
.addr-switch.switch-off b {
  background: url(../../assets/image/addr-i.png) no-repeat 0 -10px;
}
.payment-item {
  padding: 10px 12px;
}
.checkout-submit {
  margin-top: 15px;
  text-align: right;
}

.qrcode {
  .qrcode-img {
    width: 120px;
    height: 120px;
    float: left;
    background: #333;
    margin-right: 20px;
    & ~ div {
      vertical-align: middle;
    }
  }
}
.checkout-summary {
  margin-top: 15px;
  line-height: 50px;
  padding: 0 12px;
  background-color: #f4f4f4;
  color: #999;
  .summary-r {
    float: right;
  }
  .price {
    color: #ff0101;
    font-size: 18px;
    font-weight: bold;
  }
}
.bank_wrap {
  text-align: left;
  font-size: 16px;
  color: #999;
  position: relative;
  border-radius: 6px;
  overflow: hidden;
  box-shadow: 0 1px 10px 0 rgba(0, 0, 0, 0.3);
  background-color: #fff;
  height: 199.9988px;
  max-width: 640px;
  width: 350px;
  padding: 20px;
  margin: 0 auto;
  .bank_hd {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    .bank_logo {
      width: 60px;
      margin-right: 4.9988px;
    }
    .bank_name {
      font-size: 19.9988px;
      color: #000;
      margin-bottom: 4.9988px;
    }
    .payee {
      font-size: 15px;
    }
  }
  .bank_bd {
    font-size: 25.0012px;
    color: #333;
    white-space: nowrap;
    text-align: center;
    line-height: 1.5;
    padding: 19.9988px 0;
  }
  .bank_ft {
    font-size: 13.9988px;
    line-height: 1.5;
    vertical-align: -webkit-baseline-middle;
    strong {
      color: #ff0101;
      font-size: 19.9988px;
      font-weight: bold;
    }
  }
  .bank_bg {
    z-index: 1;
    right: -151.9988px;
    bottom: -129px;
    position: absolute;
    width: 300px;
    height: 300px;
    background: url(../../assets/image/hx_bank_logo.png) center center/187.5px
      auto no-repeat;
    transform: rotate(-60deg);
    opacity: 0.1;
  }
}
</style>
<script>
import dialogAddress from '../../components/dialogAddress'
import {
  Usercenter
} from "../../model/usercenter.js";
let usercenter = new Usercenter();
export default {
  name: 'wuliu',
  data() {
    return {
      consignee: false,
      showDialog: false,//显示支付信息弹窗
      dialogFormVisible: false,//显示收货地弹窗
      orderIds: [],
      orderNos: [],
      productId: this.$route.query.productId || '',
      btnState: false,
      payType: 'NATIVE',
      list: [],
      dealPrice: 0,
      realPrice: 0,
      coupon: {
        face_amount: ''
      },
      saleType: '',
      nowtime: '',
      addlist: [],//原始数组
      form: {
        value: [''],
        phone: "",
        receive: "",
        address: "",
        isDefault: false,
        selectArr: [],
        radioIndex: ""
      },
      QRImages: "",
      radioIndex: 0,
      radio: "",
      detail: {},
      timer: 0,//获取支付结果定时器
      COUNT: 0,
      MAXCOUNT: 6
    }
  },
  components: {
    dialogAddress
  },
  computed: {
    consigneeTxt() {
      if (this.consignee) {
        return '收起地址'
      } else {
        return '展开地址'
      }
    },
    //新的地址列表
    addrList: {
      get: function () {
        let _this = this;
        if (_this.addlist.length > 0) {
          if (_this.consignee) {
            return _this.addlist
          }
          let newArr = [];
          let index = _this.addlist.findIndex(item => item.id === _this.radio);
          if (index >= 0) {
            _this.radioIndex = index;
            _this.radio = _this.addlist[index].id;
            newArr.push(_this.addlist[index])
          }
          else {
            _this.radio = _this.addlist[0].id;
            newArr.push(_this.addlist[0])
          }
          // console.log(_this.radio)
          return newArr
        }
        return []
      },
      set: function (val) {
        this.addrList = val
      }
    }
  },
  methods: {
    consigneeAll() {
      this.consignee = !this.consignee
    },
    getAddressByCustomsId() {
      let _this = this;
      usercenter.addressByCustomsId({
        is_default: 0,
        customer_id: _this.user ? _this.user.id : ""
      }).then(function (res) {
        _this.addlist = res;
      })
    },
    payInfo() {
      let _this = this;
      usercenter.payInfo({
        CustomerId: _this.user ? _this.user.id : "",
        ProductId: _this.productId,
        OrderIds: _this.orderIds.join(',')
      }).then((res) => {
        _this.list = res.data.Products;
        _this.dealPrice = res.data.DealPrice;
        _this.realPrice = res.data.RealPrice;
        if (res.Coupon) {
          //_this.coupon = response.data.coupon;
          _this.coupon.face_amount = res.data.Coupon.face_amount;
        }
        if (_this.list && _this.list.length > 0) {
          //_this.nowtime = res.CurrentTime;
          _this.saleType = _this.list[0].SaleType;
          _this.detail = _this.list[0];
          if (_this.saleType === '3' || _this.saleType === 3) {
            return
          } else {
            _this.btnState = true;
          }
        }
      })
    },
    deleteAdress(id) {
      let _this = this;
      usercenter.deleteAdress({
        id: id
      }).then(() => {
        _this.$message({
          message: '删除成功',
          type: 'success'
        });
        _this.getAddressByCustomsId()
      })
    },
    setDefaultAddress(data) {
      let _this = this;
      usercenter.defaultAddress({
        id: data,
        customer_id: _this.user ? _this.user.id : ""
      }).then(() => {
        _this.$message({
          message: '设置默认地址成功',
          type: 'success'
        });
        _this.getAddressByCustomsId()
      }, () => {

      })
    },
    handleFormVisible() {//显示地址弹窗
      this.dialogFormVisible = true;
    },
    handleFormVisibleClose() {//隐藏地址弹窗
      this.dialogFormVisible = false;
    },
    handleUpdateAddress(item) {
      let _this = this;
      let arr = [];
      arr[0] = item.province;
      arr[1] = item.city;
      arr[2] = item.area;
      _this.form.id = item.id;
      _this.form.address = item.address;
      _this.form.receive = item.receive;
      _this.form.phone = item.phone;
      _this.form.selectArr = arr;
      _this.form.value = arr;
      _this.form.isDefault = item.is_default ? true : false;
    },
    beforeUpdateAddress(item) {
      this.handleFormVisible();
      this.handleUpdateAddress(item)
    },
    resetValue() {
      let _this = this;
      _this.form.id = '';
      _this.form.address = '';
      _this.form.receive = '';
      _this.form.phone = '';
      _this.form.selectArr = [];
      _this.form.value = [''];
      _this.form.isDefault = false;
    },
    beforeCreateAddress() {
      let _this = this;
      _this.resetValue();
      this.handleFormVisible();
    },
    handleDialogTarget(data) {
      let _this = this;
      if (data.msg) {
        _this.$message({
          message: '新建地址成功',
          type: 'success'
        });
        //获取地址列表重新
        _this.getAddressByCustomsId()
      } else {
        _this.$message({
          message: data.data,
          type: 'error'
        });
      }
    },
    createdNativePay() {
      let _this = this;
      if (this.payType == 'NATIVE') {
        if (_this.radio) {
          usercenter.createNativePayOrder({
            Type: 3,
            CustomerId: _this.user ? _this.user.id : '',
            OrderId: _this.orderIds.join(','),
            OrderNo: _this.orderNos.join(','),
            AddressId: _this.radio
          }).then((res) => {
            _this.QRImages = res.QRUrl;
            _this.showDialog = true;
            _this.orderId = res.OrderId;
            this.timer && clearInterval(this.timer);
            this.payOrderQuery()
            this.timer = setInterval(() => {
              _this.COUNT++;
              _this.intervalOrderQuery()
            }, 10000);
          }, () => {
          })
        } else {
          this.$message({
            message: '请选择收货地址',
            type: 'error'
          });
        }

      } else {
        _this.showDialog = true;
      }
    },
    payOrderQuery() {
      let _this = this;
      usercenter.payOrderQuery({
        OrderId: _this.orderId,
        PayType: _this.payType
      }).then(() => {
        this.$message({
          message: '订单支付成功',
          type: 'success'
        });
        _this.clearOrderQueryInterval();
        setTimeout(() => {
          _this.$router.push({ path: '/usercenter/order' })
        }, 2000);
      }, () => {
        console.log('正在支付中，请稍候')
      })
    },
    clearOrderQueryInterval() {
      this.showDialog = false;
      clearInterval(this.timer)
    },
    intervalOrderQuery() {
      if (this.COUNT >= this.MAXCOUNT) {
        this.$message({
          message: '支付失败，请重试',
          type: 'error'
        });
        this.clearOrderQueryInterval()
      } else {
        this.payOrderQuery();
      }
    },
  },
  created() {

  },
  mounted() {
    let _this = this;
    if (_this.$route.query.productId) {
      this.payInfo();
      this.$message({
        message: '暂时不支持秒杀订单支付 ，请在手机端支付',
        type: 'error'
      });
    } else {
      if (_this.$route.query.orderIds && _this.$route.query.orderNos) {
        _this.orderIds = _this.$route.query.orderIds.split(',');
        _this.orderNos = _this.$route.query.orderNos.split(',');
        this.payInfo()
        this.getAddressByCustomsId();
      } else {
        return
      }
    }
  },
  watch: {
    'addlist': function (newVal) {
      let _this = this;
      if (newVal.length > 0) {
        let index = newVal.findIndex(item => item.is_default === 1);
        if (index >= 0) {
          _this.radioIndex = index;
          _this.radio = newVal[index].id;
        } else {
          _this.radio = newVal[0].id;
        }
      } else {
        _this.radioIndex = 0;
        _this.radio = "";
      }
    }
  },
  destroyed() {
    this.clearOrderQueryInterval()
  }
}
</script>
<style lang="scss" scoped>
@import "../../assets/card.scss";
</style>